import { render, staticRenderFns } from "./TemplateReturn.vue?vue&type=template&id=6249c258&scoped=true&name=template-return&"
import script from "./TemplateReturn.vue?vue&type=script&lang=js&"
export * from "./TemplateReturn.vue?vue&type=script&lang=js&"
import style0 from "./TemplateReturn.vue?vue&type=style&index=0&id=6249c258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6249c258",
  null
  
)

/* custom blocks */
import block0 from "./TemplateReturn.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports